import * as yup from 'yup';
import { _regularExpressions } from '../Services/_regularExpressions';

export const _aboutyouState = (function () {
  let foreName = "";
  let surName = "";
  let contact = "";
  let email = "";
  let organisation = "";
  let department = "";
  let teamContact = "";
  let chkConsent = "";
  let consentText = "";

  const getForeName = function () { return foreName; };
  const setForeName = function (name) { foreName = name; };
  const getSurName = function () { return surName; };
  const setSurName = function (name) { surName = name; };
  const getContact = function () { return contact; };
  const setContact = function (name) { contact = name; };
  const getEmail = function () { return email; };
  const setEmail = function (name) { email = name; };
  const getOrganisation = function () { return organisation; };
  const setOrganisation = function (name) { organisation = name; };
  const getDepartment = function () { return department; };
  const setDepartment = function (name) { department = name; };
  const getTeamContact = function () { return teamContact; };
  const setTeamContact = function (name) { teamContact = name; };
  const getChkConsent = function () { return chkConsent; };
  const setChkConsent = function (name) { chkConsent = name; };
  const getConsentText = function () { return consentText; };
  const setConsentText = function (name) { consentText = name; };

  const resetAboutyouState = function () {
    setForeName("");
    setSurName("");
    setContact("");
    setEmail("");
    setOrganisation("");
    setDepartment("");
    setTeamContact("");
    setChkConsent("");
    setConsentText("");
  };

  return {
    getForeName: getForeName,
    setForeName: setForeName,
    getSurName: getSurName,
    setSurName: setSurName,
    getContact: getContact,
    setContact: setContact,
    getEmail: getEmail,
    setEmail: setEmail,
    getOrganisation: getOrganisation,
    setOrganisation: setOrganisation,
    getDepartment: getDepartment,
    setDepartment: setDepartment,
    getTeamContact: getTeamContact,
    setTeamContact: setTeamContact,
    getChkConsent: getChkConsent,
    setChkConsent: setChkConsent,
    getConsentText: getConsentText,
    setConsentText: setConsentText,
    resetAboutyouState: resetAboutyouState
  }

})();

const yupValidation = yup.object().shape({
  foreName: yup.string().trim()
    .required("Enter your forename")
    .matches(_regularExpressions.letterPattern, 'Forename is not valid')
    .max(150, (validationObj) => {return `Forename must be ${validationObj.max} characters or less`}),
  surName: yup.string().trim()
    .required("Enter your surname")
    .matches(_regularExpressions.letterPattern, 'Surname is not valid')
    .max(150, (validationObj) => {return `Surname must be ${validationObj.max} characters or less`}),
  contact: yup.string().trim()
    .required("Enter your contact number")
    .matches(_regularExpressions.phonePattern, _regularExpressions.phonePatternError)
    .max(16, (validationObj) => {return `Contact number must be ${validationObj.max} characters or less`}),
  email: yup.string().trim()
    .required("Enter your email address")
    .matches(_regularExpressions.emailPattern, _regularExpressions.emailPatternError)
    .max(200, (validationObj) => {return `Email must be ${validationObj.max} characters or less`}), 
  teamContact: yup.string().trim()
    .required("Enter the number or email of your team or a colleague who can be contacted if you are not available")
    .max(200, (validationObj) => {return `Team contact must be ${validationObj.max} characters or less`}),
  chkConsent: yup.string().trim().required("Select yes/no if the person being referred is aware of this referral and has given consent").nullable(),
  consentText: yup.string().ensure().when('chkConsent', {
    is: (chkConsent) => chkConsent === 'no',
      then: yup.string().trim()
            .required("Enter explanation")
            .max(200, (validationObj) => {return `Explanation must be ${validationObj.max} characters or less`})
  })
})
  .when((value, schema) => {
    const org = _aboutyouState.getOrganisation();
    if (org.length === 0) {
      return schema.shape({
        organisation: yup.string().trim().required("Select the organisation you work for")
      });
    }
  })
  .when((value, schema) => {
    const dept = _aboutyouState.getDepartment();
    if (dept.length === 0) {
      return schema.shape({
        department: yup.string().trim().required("Select the department you work for")
      });
    }
  });

export const formOptions = yupValidation;